import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { fmtDate } from "@/lib/formatters";

/**
 * /mapa-filtrado index — list every filtered map saved in the system.
 * Click a row to open detail view at /mapa-filtrado/:id.
 */
export default function FilteredMapList() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/filtered-maps").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-5" data-testid="filtered-maps-list">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">
          Mapa Filtrado
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Mapas gerados a partir do mapa bruto, apenas com sua equipe.
        </p>
      </div>
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-0 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200 text-xs uppercase tracking-wider text-slate-600">
              <tr>
                <th className="text-left px-4 py-3">Data</th>
                <th className="text-left px-4 py-3">Hospital</th>
                <th className="text-left px-4 py-3">Linhas</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="w-32"></th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-center p-8 text-slate-400">
                    Nenhum mapa filtrado. Vá em "Mapa Bruto" e gere um.
                  </td>
                </tr>
              )}
              {items.map((m, i) => (
                <tr
                  key={m.id}
                  className="border-b border-slate-100 hover:bg-slate-50/50"
                  data-testid={`fmap-row-${i}`}
                >
                  <td className="px-4 py-3">{fmtDate(m.map_date)}</td>
                  <td className="px-4 py-3">{m.hospital_name || "—"}</td>
                  <td className="px-4 py-3">
                    {(m.rows || []).filter((r) => r.included).length}
                  </td>
                  <td className="px-4 py-3 capitalize text-slate-600">{m.status}</td>
                  <td className="px-4 py-3 text-right">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => nav(`/mapa-filtrado/${m.id}`)}
                    >
                      Abrir
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
